/* eslint-disable @typescript-eslint/no-explicit-any*/
import { getInstance } from '@portal/repositories/securitySdkConfig';

const NotificationApi = {
  getNotifications: async (params: any) => {
    const instance = await getInstance();
    const { data } = await instance.get('/notification', { params });

    return data;
  },
  createNotification: async (params: any) => {
    const instance = await getInstance();
    const { data } = await instance.post('/notification', params);

    return data;
  },
};

export default NotificationApi;
